import React, { useEffect, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { googleAuthSession } from '../services/api';

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH

const AuthCallback = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const hasProcessed = useRef(false);

  useEffect(() => {
    // Prevent double processing in StrictMode
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const processAuth = async () => {
      // Extract session_id from URL fragment
      const hash = location.hash;
      const params = new URLSearchParams(hash.replace('#', ''));
      const sessionId = params.get('session_id');

      if (!sessionId) {
        console.error('No session_id found in URL');
        navigate('/login');
        return;
      }

      try {
        // Exchange session_id for user data
        const data = await googleAuthSession(sessionId);
        
        if (data.user && data.token) {
          // Success - redirect to home
          navigate('/', { replace: true, state: { user: data.user } });
        } else {
          throw new Error('Invalid response from auth');
        }
      } catch (error) {
        console.error('Auth callback error:', error);
        navigate('/login', { 
          replace: true, 
          state: { error: 'Google login mislukt. Probeer opnieuw.' } 
        });
      }
    };

    processAuth();
  }, [location.hash, navigate]);

  return (
    <div className="min-h-screen bg-gradient-to-br from-[#1a2332] via-[#2d3e50] to-[#1a2332] flex items-center justify-center">
      <div className="text-center">
        <div className="animate-spin rounded-full h-16 w-16 border-b-4 border-[#FDB913] mx-auto mb-4"></div>
        <p className="text-white text-lg">Inloggen met Google...</p>
      </div>
    </div>
  );
};

export default AuthCallback;
